import styled from '@emotion/styled';
import { DialogModal, Typography } from 'src/components-dummy';

export const HTMLSnippetModalStyled = styled(DialogModal)`
  .MuiPaper-root {
    width: 520px;
    height: 378px;
  }

  .html-snippet {
    overflow-wrap: break-word;
  }
`;

export const LearnMoreLinkWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: -12px;
  gap: 8px;
`;

export const LearnMoreLink = styled(Typography)`
  color: ${({ theme }) => theme.palette.custom['primary-main']} !important;
  align-content: center;
  display: inline-flex;
  font-size: 12px;
  text-decoration: underline;
  gap: 10px;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 8px;
  top: 8px;
  border: none;
  background-color: transparent;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg,
  rect {
    fill: transparent;
    transform: scale(1.5);
    background-color: none;
  }

  svg path {
    stroke: black;
  }

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.palette.custom['gray-80']};
  }
`;
